const Styles = {
    SIDE_PADDING: '20px',
    ROW_PADDING: '10px',
    DRAWER_WIDTH: 240,
    DRAWER_WIDTH_CLOSED: 65,
}

export default Styles
